// 高保真保护区弹窗的布局计算：
// - PC 下默认按 70% 视口宽度打开，但整体不小于 920px
// - 右侧列表在宽屏时保持当前视觉宽度，收窄到基线时同步压缩，但保留最小可读宽度
// - 左侧 PDF 渲染区使用剩余宽度，确保左右两栏一起缩放，而不是只压缩左侧
const PROTECT_AREA_DRAWER_RATIO = 0.7
const PROTECT_AREA_MIN_DRAWER_WIDTH = 920
const PROTECT_AREA_REFERENCE_DRAWER_WIDTH = 1000
const PROTECT_AREA_RIGHT_OUTER_WIDTH = 340
const PROTECT_AREA_MIN_RIGHT_OUTER_WIDTH = 320
const PROTECT_AREA_RIGHT_INNER_PADDING = 20
const PROTECT_AREA_PDF_GUTTER = 24
const PROTECT_AREA_MIN_PDF_RENDER_WIDTH = 320

export function resolveProtectAreaLayout({ viewportWidth, isMobile }) {
  const safeViewportWidth = Math.max(0, Number(viewportWidth) || 0)
  const drawerWidth = isMobile
    ? safeViewportWidth
    : Math.max(PROTECT_AREA_MIN_DRAWER_WIDTH, Math.floor(safeViewportWidth * PROTECT_AREA_DRAWER_RATIO))
  const drawerSize = isMobile ? '100%' : `${drawerWidth}px`

  // 宽屏下保持右侧列表原有宽度；当抽屉收窄到基线时按比例压缩，
  // 但保留一个最小外宽，避免列表内容被压得过窄。
  const drawerScale = isMobile ? 1 : Math.min(1, drawerWidth / PROTECT_AREA_REFERENCE_DRAWER_WIDTH)
  const rightOuterWidth = isMobile
    ? Math.min(PROTECT_AREA_RIGHT_OUTER_WIDTH, drawerWidth)
    : Math.max(PROTECT_AREA_MIN_RIGHT_OUTER_WIDTH, Math.round(PROTECT_AREA_RIGHT_OUTER_WIDTH * drawerScale))
  const leftOuterWidth = Math.max(0, drawerWidth - rightOuterWidth)

  // 右侧组件自身有左右 padding，内部宽度需要扣掉这部分，才能和外层容器对齐。
  const rightInnerWidth = Math.max(0, rightOuterWidth - PROTECT_AREA_RIGHT_INNER_PADDING)
  const pdfRenderWidth = Math.max(PROTECT_AREA_MIN_PDF_RENDER_WIDTH, leftOuterWidth - PROTECT_AREA_PDF_GUTTER)

  return {
    drawerSize,
    drawerWidth,
    leftOuterWidth,
    pdfRenderWidth,
    rightInnerWidth,
    rightOuterWidth,
  }
}
